import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.PIPELINES,
  displayName: "Concurrent Pipelines Builds",
  displayOrder: 2,
  isCustomerFacing: true,
  cardConfig: {
    isTrial: () => false,
    icon: "build-minutes-icon",
    title: "Concurrent Pipelines Builds",
    valueTransformer: (value) => Number(value).toLocaleString("en-US"),
    valueTransformerSH: (value) => {
      return {
        display: value !== "N/A",
        value: Number(value).toLocaleString("en-US"),
        units: "Min",
      };
    },
  },
};

export default entitlement;
